import { computed as pcomputed, effect as peffect, signal as psignal, } from '@preact/signals-core';
import { implementService } from '../../helpers.js';
import { SignalsServiceDefinition, } from './definition.js';
export const SignalsServiceFactory = implementService(SignalsServiceDefinition, () => {
    const signalsRegistry = [];
    return {
        signal: (initialValue) => {
            const sig = psignal(initialValue);
            const signal = {
                get: () => sig.value,
                set: (newValue) => (sig.value = newValue),
            };
            signalsRegistry.push(signal);
            return signal;
        },
        computed: (fn) => {
            const sig = pcomputed(fn);
            const signal = {
                get: () => sig.value,
            };
            signalsRegistry.push(signal);
            return signal;
        },
        effect: peffect,
        getSignalsRegistry: () => signalsRegistry,
    };
});
